import {
  pollPatientDocumentStatus,
  submitPatientDocument,
} from "../api/documentService";

export function generateDocumentRequestId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `req-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function getDocumentUploadErrorMessage(err) {
  const status = err?.response?.status;
  const responseData = err?.response?.data;
  const serverMsg = responseData?.detail
    || responseData?.message
    || responseData?.error
    || (typeof responseData === "string" ? responseData : null)
    || err?.message;

  if (status) {
    return `Document scan failed (${status})${serverMsg ? `: ${serverMsg}` : ""}`;
  }
  return serverMsg || "Failed to process document. Please try again.";
}

/**
 * Desktop direct-upload OCR flow — mirrors RegisterPatientForIpd.js handleOcrSubmit.
 */
export async function processDocumentUpload(file) {
  const generatedRequestId = generateDocumentRequestId();
  const submitRes = await submitPatientDocument(file, generatedRequestId);
  const requestId = submitRes?.request_id || generatedRequestId;

  if (submitRes?.status !== "Success" || !requestId) {
    return {
      ok: false,
      error: submitRes?.message || "Could not submit the document for processing.",
    };
  }

  const documentJson = await pollPatientDocumentStatus(requestId);
  if (!documentJson) {
    return {
      ok: false,
      error: "Document is taking longer than expected to process. Please try again.",
    };
  }

  return { ok: true, documentJson };
}
